import ProductDetailView from './ProductDetailView';

const views = {
  ProductDetailView,
};
export default views;
